import React from 'react';
import NumberFormat from 'react-number-format';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import store from '../../store';
import { getEffectivePrice } from '../../utils/shared.utils';
import './product-item.scss';

interface ProductProps {
    product: any,
    basket: any,
    client: any,
}

interface ProductState {
    showBasketLine: boolean,
    basketCount: number,
    basketMsg: string
}

const mapStateToProps = (state: any, props: any) => {
    let basketCount = 0;
    if (state.basket && state.basket.quantityById && props && props.product) {
        if (state.basket.quantityById[props.product.id]) {
            basketCount = state.basket.quantityById[props.product.id];
        }
    }
    return {
        basket: state.basket,
        basketCount: basketCount,
        client: state.client,
    }
}

class ProductItem extends React.Component<ProductProps, ProductState> {
    private componentRef = React.createRef<HTMLDivElement>();

    constructor(props: any) {
        super(props);
        let basketCount = 0;

        if (this.props.basket && this.props.basket.quantityById) {
            if (this.props.basket.quantityById[this.props.product.id]) {
                basketCount = this.props.basket.quantityById[this.props.product.id];
            }
        }
        this.state = {
            showBasketLine: false,
            basketCount: basketCount,
            basketMsg: ""
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.basketCount != null) {
            let state = { basketCount: nextProps.basketCount, showBasketLine: this.state.showBasketLine};
            if (nextProps.basketCount === 0) {
                state.showBasketLine = false;
            }
            this.setState(state);
        }
    }

    handleClickOutside = (event: MouseEvent) => {
        if (this.componentRef.current && !this.componentRef.current.contains(event.target as Node)) {
            if (this.state.showBasketLine) {
                this.setState({ showBasketLine: false });
            }
        }
    }

    toggleTopLine() {
        if (!this.state.showBasketLine && this.state.basketCount === 0) {
            this.increaseBasketCount();
        }
        this.setState({ showBasketLine: !this.state.showBasketLine });
    }

    increaseBasketCount() {
        if (this.state.basketCount + 1 > this.props.product.warehouseCount) {
            this.setState({ basketMsg: "Боломжит үлдэгдэл: " + this.props.product.warehouseCount })
            return;
        }
        this.setState({ basketCount: this.state.basketCount + 1 });
        store.dispatch({
            type: 'addToBasket',
            product: this.props.product,
            count: 1
        });
    }

    decreaseBasketCount() {
        this.setState({ basketMsg: ""})
        if (this.state.basketCount === 0) {
            return;
        }
        if (this.state.basketCount === 1) {
            this.toggleTopLine();
        }
        this.setState({ basketCount: this.state.basketCount - 1 });
        store.dispatch({
            type: 'removeFromBasket',
            product: this.props.product
        });
    }

    onItemCountChange = (e: any) => {
        const rawValue = e.target.value;
        if (!rawValue || rawValue === "0") {
            // Only update local state here — dispatching to Redux would flip basketCount
            // to 0 in props, which componentWillReceiveProps collapses the line for
            // (showBasketLine: false), unmounting this input before blur can commit the
            // removal below. The actual removal is deferred to onItemCountBlur.
            this.setState({ basketCount: 0 });
            return;
        }
        const count = Number(rawValue);
        if (isNaN(count) || count < 0) {
            return;
        }
        if (count > this.props.product.warehouseCount) {
            this.setState({ basketMsg: "Боломжит үлдэгдэл: " + this.props.product.warehouseCount });
            return;
        }
        this.setState({ basketCount: count, basketMsg: "" });
        store.dispatch({ type: 'updateBasketItemCount', product: this.props.product, count: count });
    }

    onItemCountBlur = (e: any) => {
        if (!e.target.value || e.target.value === "0") {
            const basket: any = store.getState().basket;
            const currentQty = basket?.quantityById?.[this.props.product.id];
            if (currentQty !== undefined && currentQty !== null) {
                store.dispatch({ type: 'removeItemFromBasket', product: this.props.product });
            }
            this.setState({ showBasketLine: false });
        }
    }

    render() {
        return (
            <div ref={this.componentRef} className={`product-detail-item ${this.state.basketCount > 0 ? "selected" : ""}`}>
                { this.props.product.warehouseCount === 0 ? null :
                    this.state.showBasketLine ?
                        <div className="basket-line">
                            <div className="background"></div>
                            <div className="flex-line">
                                <Icon className="flex-child" name="minus" onClick={() => this.decreaseBasketCount()}/>
                                <input
                                    type="number"
                                    min={0}
                                    className="flex-child count"
                                    value={this.state.basketCount}
                                    onChange={this.onItemCountChange}
                                    onBlur={this.onItemCountBlur}
                                    onFocus={(e: any) => e.target.select()}
                                />
                                <Icon className="flex-child" name="plus" onClick={() => this.increaseBasketCount()}/>
                            </div>
                            <div className="close-line" onClick={() => this.toggleTopLine()}>
                                <div className="basket-msg">{ this.state.basketMsg }</div>
                                <span>Хаах</span>
                            </div>
                        </div> :
                        <div className="top-line" onClick={() => this.toggleTopLine()}>
                            {
                                (this.state.basketCount > 0) ? 
                                <span className="count-in-basket">{ this.state.basketCount }</span> : 
                                <Icon name="plus" size="small" className="plus-icon"/>
                            }
                        </div>
                }
                <Link to={"/product/" + this.props.product.slug} className="product-item">
                    <img className="product-image" src={this.props.product.imageSmUrl}/>
                </Link>
                <Link to={"/product/" + this.props.product.slug} className="text-center">
                    <div className="product-title">{this.props.product.name}</div>
                </Link>
                <div className="product-info">
                    {this.props.product.info}
                </div>
                { this.props.product.warehouseCount === 0 ? <div className="warehouse-line">Үлдэгдэл байхгүй</div> : null }
                { (() => {
                    const p = this.props.product;
                    const isClubMember = this.props.client?.company?.clubMember;
                    const effectivePrice = getEffectivePrice(p, isClubMember);
                    const isSale = (p as any).saleActive && (p as any).salePrice > 0;
                    const showStrike = effectivePrice !== p.price;

                    let priceBlock;
                    if (showStrike && isClubMember && !isSale) {
                      priceBlock = (
                        <>
                          <div className='original-line'>
                            <span className='original-price'>
                                <div className='club-original-price'>
                              <NumberFormat displayType={"text"} value={p.price} suffix=' ₮' thousandSeparator={true} />
                              </div>
                            </span>
                            { p.size && p.unit ? <span className='unit-text'> / {p.size} {p.unit}</span> : null }
                          </div>
                          <div className='price-block discounted'>
                            <div className='price-type-label club'>CLUB PRICE</div>
                            <div className='effective-price'>
                              <NumberFormat displayType={"text"} value={effectivePrice} suffix=' ₮' thousandSeparator={true} />
                            </div>
                          </div>
                        </>
                      );
                    } else if (showStrike && isSale) {
                      priceBlock = (
                        <>
                          <div className="sale-line">
                            <span className="sale">Sale</span>
                          </div>
                          <div className="price-line">
                            <span className="price">
                              <NumberFormat displayType={'text'} value={effectivePrice} suffix="₮" thousandSeparator={true} />
                            </span>
                            <span className="price-per">
                              {(p.size > 0 && p.unit) ? `/ ${p.size} ${p.unit}` : ""}
                            </span>
                          </div>
                        </>
                      );
                    } else {
                      priceBlock = (
                        <>
                        <div className="price-line">
                            <span className="price">
                                <NumberFormat displayType={'text'} value={effectivePrice} suffix="₮" thousandSeparator={true}/>
                            </span>
                            <span className="price-per">{ (p.size > 0 && p.unit) ? `/ ${p.size} ${p.unit}` : "" }</span>
                        </div>
                        </>
                      );
                    }
                    return priceBlock;
                })() }
            </div>
        );
    }
}

export default connect(mapStateToProps)(ProductItem);